import Block2ColumnsIntegrationList from './twoColumnsIntegrationList'

export default Block2ColumnsIntegrationList
